export default __webpack_public_path__ + "static/media/320x180.5ed74992.jpg";